import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage || i18n.language || 'tr';

  useEffect(() => {
    document.documentElement.lang = currentLanguage.split('-')[0];
  }, [currentLanguage]);

  const changeLanguage = (language) => {
    window.localStorage.setItem('kaed-language', language);
    i18n.changeLanguage(language);
  };

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <button onClick={() => changeLanguage('tr')} aria-pressed={currentLanguage.startsWith('tr')}>TR</button>
      <button onClick={() => changeLanguage('en')} aria-pressed={currentLanguage.startsWith('en')}>EN</button>
    </div>
  );
};

export default LanguageSwitcher;
